import { BitfPApiCallStateMapper } from '@common/libs/bitforce/core/api-call-state/bitf-p-api-call-state';

export class DefaultApiCallStateMapper extends BitfPApiCallStateMapper {}
